import { merge } from '../../helper';

import addClass from '../../general/class/addClass';
import isEmptyArray from '../../general/isEmpty/isEmptyArray';
import removeClass from '../../general/class/removeClass';

import exExternal from '../../external';
import * as exElement from '../../utils/element';
import * as exLink from '../../utils/link';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        bootstrap: {
            enabled: true,
        },
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (nav tab)
    const elNavTab = exElement.create({
        merge: defConfig,
    });
    elements.element = elNavTab;

    // ------------------------------------------------------------------------

    // If false, is not using nav
    if (defConfig.nav !== false) {
        // Create element (nav)
        const elNav = exElement.create({
            merge: defConfig.nav,
            tag: 'ul',
            class: {
                new: 'nav nav-tabs',
            },
            style: {
                marginBottom: '1rem',
            },
        });
        elNavTab.appendChild(elNav);
        elements.nav = elNav;
    }

    // If false, is not using tab
    if (defConfig.tab !== false) {
        // Create element (tab)
        const elTab = exElement.create({
            merge: defConfig.tab,
            class: {
                new: 'tab-content',
            },
        });
        elNavTab.appendChild(elTab);
        elements.tab = elTab;
    }

    // ------------------------------------------------------------------------

    // If using data
    if (!isEmptyArray(defConfig.data)) {
        elements.items = [];

        // Init
        let isActive = false;

        // Foreach Data
        for (let i = 0; i < defConfig.data.length; i++) {
            const itemConfig = defConfig.data[i];

            // Default Config Item
            const defConfigItem: Record<string, any> = {
                title: '{title' + (i + 1) + '}',
                link: 'nav-link-' + (i + 1),
            };

            // Merge
            merge(defConfigItem, itemConfig);

            // ----------------------------------------------------------------

            // If false, is not using nav
            if (defConfig.nav !== false) {
                elements.navs = elements.navs || [];
                elements.links = elements.links || [];

                // Create element (nav item)
                const elNavItem = exElement.create({
                    merge: defConfig.navItem,
                    tag: 'li',
                    class: {
                        new: 'nav-item',
                    },
                });
                elements.nav.appendChild(elNavItem);

                // Navs Push
                elements.navs[i] = elNavItem;

                // ------------------------------------------------------------

                // Create element (nav link)
                const link = exLink.create({
                    merge: defConfig.navLink,
                    class: {
                        new: 'nav-link',
                    },
                    dataset: {
                        bsTarget: '#' + defConfigItem.link,
                        bsToggle: 'tab',
                    },
                    html: defConfigItem.title,
                });
                elNavItem.appendChild(link.element);

                // Links Push
                elements.links[i] = link.element;
            }

            // ----------------------------------------------------------------

            // If false, is not using tab
            if (defConfig.tab !== false) {
                elements.tabs = elements.tabs || [];

                // Create element (tab item)
                const elTabItem = exElement.create({
                    merge: defConfig.tabItem,
                    class: {
                        new: 'tab-pane fade',
                    },
                    attr: {
                        id: defConfigItem.link,
                    },
                    html: defConfigItem.message || defConfigItem.html,
                });
                elements.tab.appendChild(elTabItem);

                // Tabs Push
                elements.tabs[i] = elTabItem;
            }

            // ----------------------------------------------------------------

            //
            if (defConfig.nav !== false && defConfig.tab !== false) {
                // If using active
                if (defConfigItem.active === true && !isActive) {
                    addClass(elements.links[i], 'active');
                    addClass(elements.tabs[i], 'show active');

                    isActive = true;
                }
            }

            // ----------------------------------------------------------------

            // Items Push
            elements.items.push({
                nav: elements.navs[i],
                link: elements.links[i],
                tab: elements.tabs[i],
            });
        }

        // --------------------------------------------------------------------

        //
        if (defConfig.nav !== false && defConfig.tab !== false) {
            // If active is false, add the first active element
            if (!isActive) {
                addClass(elements.items[0].link, 'active');
                addClass(elements.items[0].tab, 'show active');
            }
        }
    }

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // If using bootstrap
    if (defConfig.bootstrap?.enabled === true) {
        // Bootstrap (tab)
        const bsTab = new exExternal.bootstrap.Tab(elements.element);
        elements.bs = bsTab;
    }

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // If false, is not using nav
    if (config.nav !== false) {
        // If using pills
        if (config.pills === true) {
            removeClass(elements.nav, 'nav-tabs');
            addClass(elements.nav, 'nav-pills');
        }

        // If using fill
        if (config.fill === true) {
            addClass(elements.nav, 'nav-fill');
        }
    }
}

// ----------------------------------------------------------------------------

export { create };
